// extracted by mini-css-extract-plugin
export default {"landingPageButton":"LandingPageButton_landingPageButton__1thLN"};